// @file Entrypoint for home page
import { captureException } from 'bits/error_tracker'
import window from 'bits/global'
import { setupVueApp } from 'bits/vue'
import { useLandsideStore } from 'pinia/landside'
import { useLandsideNavigationStore } from 'pinia/landside_navigation'
import { usePlansStore } from 'pinia/plans'
import LandsideApp from 'vuecomponents/LandsideApp.vue'

setupVueApp({
  el: '#landside',
  rootComponent: LandsideApp,
  initializeStore(store) {
    store.dispatch('initializeState').catch(captureException)
  },
  usePinia: true,
})
  .then((vueInstance) => {
    window.app = vueInstance
    useLandsideNavigationStore().initializeState(window.ww.vueStartingState)
    useLandsideStore().initializeState(window.ww.vueStartingState)
    usePlansStore().initializeState(window.ww.vueStartingState)
  })
  .catch(captureException)
